<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12TYBAV/tc-custom/cover.jpg?1649014393294" alt="This image is the cover for the book Correo Simple"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Correo Simple
      </h1>
      <p class="bookDescription body article font2">
        <p>En el día más importante, una simple carta cambia la vida de Adele para siempre. El viaje para descubrir la verdad la llevará al encanto de Tenerife.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eleonora Persichetti, Erin Zulema Pacheco
      </h2>
      
      <p class="authorDescription body article">Eleonora Persichetti nació en Frascati el 22 de abril de 1981 y vive en Marino, en la provincia de Roma. Descubrió su pasión por la escritura cuando jugaba con muñecas, de hecho, escribió poesía e historias desde que tenía 6 años. Es licenciada en idiomas, profesora de idiomas, periodista y actualmente trabaja en Ansa e Inail. Es la directora de "Ugualmente abile News", la redactora jefa de "La Voce dei Castelli",  trabaja como freelance para algunos medios de comunicación locales y nacionales. Ha ganado varios concursos de poesía, incluidos los internacionales (como la Diversidad Literaria española), y muchos libros se publican en antologías literarias. En 2006 publicó un ensayo en "Sincronie": "La técnica de alusiones en los poemas de Andrew Marvell". En 2008 escribió una historia, "Linda, el tema de la anorexia", para la antología "Escríbeme esta vez", editada por EdiLet. En 2017 publicó su primer monólogo: "El fuego dentro", editado por Edizioni Zem. En 2018 publicó un ensayo sobre Andrew Marvell y un ensayo sobre la escuela inclusiva con Ediciones Académicas Italianas, y su primera novela está a punto de ser lanzada. También tradujo varias tesis universitarias y escribe para el teatro. Su primera comedia teatral fue puesta en escena el pasado junio en Roma.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?64ad43aa